import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import TextField from '@mui/material/TextField';
import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';

import { ErrorMessage } from '../ErrorMessage/ErrorMessage';

interface CheckAccessProps {
    translations: Record<string, string>;
}

export const CheckAccess: React.FC<CheckAccessProps> = ({ translations }) => {
    const [accessPointCode, setAccessPointCode] = useState('');
    const [accessPointCodeForRedirect, setAccessPointCodeForRedirect] = useState('');

    if (accessPointCode.length) {
        return <Navigate to={`/accesspoint/${accessPointCode}`} />;
    }

    return (
        <form
            onSubmit={(event) => {
                event.preventDefault();
                setAccessPointCode(accessPointCodeForRedirect);
            }}
        >
            <Card>
                <CardContent>
                    <ErrorMessage
                        errorMessage={translations.CHECK_ACCESS_TITLE}
                        showReturnButton={false}
                        title={translations.GLOBAL_ERROR_TITLE}
                        translations={translations}
                    />
                    <Box my={8}>
                        <TextField
                            fullWidth
                            label={translations.CHECK_ACCESS_INPUT_LABEL}
                            onChange={({ target }) => {
                                setAccessPointCodeForRedirect(target.value.toUpperCase().trim());
                            }}
                        />
                    </Box>
                </CardContent>
                <CardActions>
                    <Button
                        fullWidth
                        disabled={!accessPointCodeForRedirect.length}
                        variant="contained"
                        color="primary"
                        type="submit"
                        size="large"
                    >
                        {translations.CHECK_ACCESS_BUTTON}
                    </Button>
                </CardActions>
            </Card>
        </form>
    );
};
